import { useQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";

export function useTermOfUse() {

    const client = useRestClient();

	const query = useQuery({
		queryKey: ['termofuse'],
		queryFn: client.termOfUse,
		retry: false, 
        staleTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
	});

	return {
		termofuse: query.data,
		isLoading: query.isLoading,
		error: query.error,
	};

}